import { globalAxios } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    transferTokenQueueList: [],
  },
  mutations: {
    setTokenQueueList(state, data) {
      state.transferTokenQueueList = data;

      var statusQueue = [1, 3, 2, 4];
      state.transferTokenQueueList.sort(function (a, b) {
        return statusQueue.indexOf(a.queue_status) - statusQueue.indexOf(b.queue_status);
      });
    }
  },
  actions: {
    fetchTokenQueueList({ commit, dispatch }) {
      let url = `/api/v1/crypto/queue/get_queue`;
      return globalAxios
        .get(url)
        .then((res) => {
          if (res.msg == false) return false;
          commit('setTokenQueueList', res.data)
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    cancelTokenQueue({ commit, dispatch }, queueId) {
      let url = `/api/v1/crypto/queue/cancel_queue?queue_id=${queueId}`;
      return globalAxios
        .put(url, {})
        .then((res) => {
          commit('setTokenQueueList', res.data)
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    transferToken({ commit,dispatch }, payload) {
      let url = `/api/v1/crypto/transfer_token`;
      return globalAxios
        .post(url, payload)
        .then((res) => {
          // commit('setTokenQueueList', res.data)
          return res;
        })
        .catch((err) => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    }
  },
  getters: {

  },
};
